import React from 'react'
import PropTypes from 'prop-types'
import './ImagePreview.css'
import Dropzone from 'react-dropzone'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

class ImagePreview extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      imageLoaded: false,
      imageWidth: 0,
      imageHeight: 0
    }
    this._updateImage(props.image)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.image !== this.props.image) {
      this._updateImage(this.props.image)
    }
  }

  render () {
    const {image, editable, deletable, imageClassName, wrapperClassName, showDimension, dropzoneDisablePreview} = this.props

    const content = <div className={`${wrapperClassName} fields-image-preview__wrapper`}>
      {!!image && <img src={image} className={`fields-image-preview__image ${imageClassName}`} />}
      {!image && <div className='fields-image-preview__no_image'>
        <i className='fa fa-image' />
      </div>}
      <div className={'fields-image-preview__action'}>
        {editable && <div className='fields-image-preview__dropzone'>
          <Dropzone
            onDrop={this.props.onDrop}
            multiple={false}
            disablePreview={dropzoneDisablePreview}
            className='fields-image-preview__edit'
          >
            {!!image && this.props.editLabel} {!image && this.props.addLabel}
          </Dropzone>
        </div>}
        {deletable && <div className='fields-image-preview__delete' onClick={this.props.onClickDelete}>
          Delete
        </div>}
      </div>
    </div>

    if (showDimension) {
      const tooltip = <Tooltip id='image-size'>{this.state.imageWidth} x {this.state.imageHeight}</Tooltip>

      return <OverlayTrigger overlay={tooltip} placement='top'>
        {content}
      </OverlayTrigger>
    } else {
      return content
    }
  }

  _updateImage = (src) => {
    this.image = new Image()
    this.image.src = src
    this.image.onload = () => {
      this.setState({
        imageLoaded: true,
        imageWidth: this.image.width,
        imageHeight: this.image.height
      })
    }
  }
}

ImagePreview.propTypes = {
  onDrop: PropTypes.func,
  image: PropTypes.string,
  editable: PropTypes.bool,
  deletable: PropTypes.bool,
  onClickDelete: PropTypes.func,
  imageClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  showDimension: PropTypes.bool,
  editLabel: PropTypes.string,
  addLabel: PropTypes.string,
  dropzoneDisablePreview: PropTypes.bool
}

ImagePreview.defaultProps = {
  imageClassName: '',
  wrapperClassName: '',
  showDimension: false,
  editLabel: 'Edit',
  addLabel: 'Edit',
  dropzoneDisablePreview: true
}

export default ImagePreview



// WEBPACK FOOTER //
// app/javascript/components/fields/ImagePreview/ImagePreview.js